import { useEffect, useMemo, useState } from 'react';
import { IOrganization, IOrganizationConfig, ITicket } from '@tymely/atoms';
import { groupComments } from '@tymely/services';
import CloseIcon from '@tymely/components/Icons/Close';
import { styled, Backdrop, Box, IconButton, Modal } from '@mui/material';

import { TicketHeader } from '../TicketLayout/Main';
import { ConversationContainer, Discussion } from '../TicketLayout/Conversation';
import { EventModeProvider } from '../EventModeContext';

const StyledModal = styled(Modal)`
    position: fixed;
    z-index: 1300;
    inset: 0;
    display: flex;
`;

const ModalContent = styled(Box)(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    position: absolute;
    transform: translateX(-50%);
    margin-left: 50%;
    top: ${theme.spacing(2)};
    height: 90vh;
    top: 5vh;
    width: 60%;
    background-color: ${theme.palette.background.main};
    padding-bottom: 0;
    border-radius: 20px;
`,
);

export const TicketModal = (props: {
    ticket: ITicket;
    selectedCommentId: number;
    onClose?: () => void;
    organization?: IOrganization;
    organizationConfig?: IOrganizationConfig;
}) => {
    const [open, setOpen] = useState(true);
    const comments = useMemo(() => {
        return groupComments(props.ticket.comments || []);
    }, [props.ticket.comments]);

    useEffect(() => {
        setOpen(true);
    }, [props.selectedCommentId]);

    const handleClose = () => {
        setOpen(false);
        props.onClose?.();
    };

    return (
        <StyledModal open={open} slots={{ backdrop: Backdrop }} onClose={handleClose}>
            <ModalContent>
                <TicketHeader
                    ticket={props.ticket}
                    blockParallelHandling={false}
                    organization={props.organization}
                    organizationConfig={props.organizationConfig}
                />
                <ConversationContainer>
                    <EventModeProvider>
                        <Discussion
                            ticket={props.ticket}
                            comments={comments}
                            commentIdToFocusOn={props.selectedCommentId}
                            organizationConfig={props.organizationConfig}
                        />
                    </EventModeProvider>
                </ConversationContainer>
                <IconButton sx={{ position: 'absolute', top: 8, right: 8 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </ModalContent>
        </StyledModal>
    );
};
